import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import { FormFiltersBackground, PageMain } from "components/molecules";
import { QUERIES_KEYS } from "queries";
import { CourseRegistrationsByCourseRow, reportsApi } from "api/reportsApi";
import { PaziaDateSelect } from "components/atoms";
import { TanTableClient, useFilters, TanTableColumn } from "components/molecules";
import { PaziaBreadcrumbs } from "components/atoms";
import { routes } from "consts";
import { REPORTS_IDS, REPORTS_NAMES } from "consts/reports";

export const CourseRegistrationByCourseReport = () => {
  const { filter, changeFilter } = useFilters();
  const { data, isLoading, refetch } = useQuery({
    queryKey: QUERIES_KEYS.REPORTS.COURSE_REGISTRATIONS_BY_COURSE(),
    queryFn: () => reportsApi.getCourseRegistrationsByCourseReport(filter),
  });

  useEffect(() => {
    refetch();
  }, [filter]);

  const columns: TanTableColumn<CourseRegistrationsByCourseRow>[] = [
    {
      id: "courseId",
      accessorKey: "courseId",
      header: "Id",
      size: 10,
    },
    {
      id: "courseName",
      accessorKey: "courseName",
      header: "Kurs",
      size: 500,
    },
    {
      id: "numberOfRegistrations",
      accessorKey: "numberOfRegistrations",
      header: "Liczba zapisów",
    },
  ];

  const onFromDateChange = (date: Date | null) =>
    changeFilter("from", date ? `createdDate ge ${date.toISOString()}` : "");

  const onToDateChange = (date: Date | null) => changeFilter("to", date ? `createdDate le ${date.toISOString()}` : "");

  const tableData = data?.data ?? [];
  return (
    <PageMain>
      <PaziaBreadcrumbs
        segments={[
          { title: "Raporty", path: routes.REPORTS },
          { title: REPORTS_NAMES[REPORTS_IDS.COURSE_REGISTRATIONS_BY_COURSE] },
        ]}
      />
      <FormFiltersBackground>
        <div className="flex flex-wrap items-center gap-2">
          <PaziaDateSelect name="dateFrom" label="Data od" onChange={onFromDateChange} />
          <PaziaDateSelect name="dateTo" label="Data od" onChange={onToDateChange} />
        </div>
      </FormFiltersBackground>
      <div>
        <TanTableClient data={tableData} columns={columns} />
      </div>
    </PageMain>
  );
};
